import { h1 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  
`;

const HeroMainDiv = styled.div`
  background-image:url("/images/metlab-header.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center;
  position: relative;
  height: calc(100vh - 8rem);

  @media (max-width: 1024px) { 
      height: auto;
  }
  @media (max-width: 768px) { 
      height: 28em;
      justify-content: center;
      align-items: center;
  }
`;

const Title = styled(h1)`
  
`;

const BackgroundImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
  z-index: -1;
`;

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &::before {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

const MobileBGImage = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const S = {
  Container,
  HeroMainDiv,
  Title,
  BackgroundImage,
  VideoContainer,
  MobileBGImage
};

export default S;
